import React, { useState } from 'react';

const Help_Video = ({ videoId, title = "Help Video" }) => {
  const [showVideo, setShowVideo] = useState(false);

  return (
<div style={{ width: '100%' }}>
  
  {/* Button wrapper */}
  <div style={{ width: '100%', display: 'flex', justifyContent: 'center' }}>
    <button
      onClick={() => setShowVideo(!showVideo)}
      style={{
        backgroundColor: '#f06b6b',
        color: 'white',
        border: 'none',
        borderRadius: '8px',
        padding: '0.5rem 1rem',
        cursor: 'pointer',
        fontWeight: 'bold',
        fontSize: '0.9rem',
        boxShadow: '0 2px 5px rgba(0,0,0,0.2)',
        width: '100%', // keep full width if you want
        maxWidth: '400px', // 👈 prevents huge button on laptop
      }}
    >
      {showVideo ? 'Close Video ✖' : 'Watch Help Video ▶'}
    </button>
  </div>

  {/* Video wrapper */}
  {showVideo && (
    <div
      style={{
        marginTop: '1rem',
        display: 'flex',
        justifyContent: 'center',
      }}
    >
      <div
        style={{
          width: '100%',
          maxWidth: '700px', // 👈 controls desktop width (~50%)
        }}
      >
        <div
          style={{
            position: 'relative',
            width: '100%',
            paddingBottom: '56.25%',
            height: 0,
          }}
        >
          <iframe
            src={`https://www.youtube.com/embed/${videoId}`}
            title={title}
            frameBorder="0"
            allowFullScreen
            style={{
              position: 'absolute',
              width: '100%',
              height: '100%',
              borderRadius: '12px',
            }}
          />
        </div>
      </div>
    </div>
  )}

</div>
  );
};

export default Help_Video;